import React from 'react';

import { Actions, Action } from '@gogame/components';
import Permissions from '@gogame/permissions';
import { useLinkBasenameWithRoot } from '@gogame/screens';

import { TAB_CONCEPTS } from 'scenes/Gallery/GalleryPage/constants';
import { galleryLink } from 'scenes/Gallery/GalleryPage/navigation';
import {
  STATUS_MEDIA_ARCHIVED,
  PERMISSION_ARCHIVED,
} from 'scenes/Trackers/Tracker/constants';
import {
  useCopyConceptFileLink,
  useDownloadConceptFileLink,
} from 'scenes/Trackers/Tracker/data/mutations';

const ConceptActions = ({ rowData }) => {
  const copyFileLink = useCopyConceptFileLink();
  const downloadFileLink = useDownloadConceptFileLink();
  const galleryBasename = useLinkBasenameWithRoot(galleryLink);
  const id = rowData?.Dimension?.id;
  const handleCopyUrl = () => copyFileLink({ id });

  const handleExport = () => {
    downloadFileLink({ id });
  };

  const handleViewOnGallery = () => {
    const link = galleryLink.child(TAB_CONCEPTS).stringify(
      {
        searchQuery: id,
      },
      {
        basename: galleryBasename,
      }
    );
    window.open(link, '_blank');
  };

  return (
    <Permissions>
      {({ isActionAllowed }) => {
        const archivedPermissionAllowed = isActionAllowed(PERMISSION_ARCHIVED);
        return (
          <Actions limit={0}>
            <Action
              label={'Copy URL'}
              onClick={handleCopyUrl}
              disabled={
                !archivedPermissionAllowed &&
                rowData.media?.status === STATUS_MEDIA_ARCHIVED
              }
            />
            <Action
              label={'Export'}
              onClick={handleExport}
              disabled={
                !archivedPermissionAllowed &&
                rowData.media?.status === STATUS_MEDIA_ARCHIVED
              }
            />

            <Action
              label={'View on Gallery'}
              onClick={handleViewOnGallery}
              disabled={
                !archivedPermissionAllowed &&
                rowData.media?.status === STATUS_MEDIA_ARCHIVED
              }
            />
          </Actions>
        );
      }}
    </Permissions>
  );
};

export default ConceptActions;
